import { AILoading } from "@components:AILoading";
import { useCopy } from "@hooks:useCopy";
import { Box, Button, Stack, Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { HighlightNumbersInBrackets } from "@pages:app/talk/shared/HighlightNumbersInBrackets";
import { TalkFeedback } from "@pages:app/talk/shared/TalkFeedback";
import { isEmpty } from "lodash";
import { IoCheckmarkDoneOutline } from "react-icons/io5";
import { LuCopy } from "react-icons/lu";
import { MdExpandLess, MdExpandMore } from "react-icons/md";

interface AIResponseProps {
  answer?: string;
  references: any[];
  setShowReferences: (
    value: ((prevState: boolean) => boolean) | boolean,
  ) => void;
  showReferences: boolean;
  llmQuestion?: string;
  messageId?: string | null | undefined;
}

export const AIResponse = ({
  answer,
  references,
  showReferences,
  setShowReferences,
  llmQuestion,
  messageId,
}: AIResponseProps) => {
  const { copy, isCopied } = useCopy();

  return (
    <>
      {isEmpty(answer) ? (
        <AILoading />
      ) : (
        <Box>
          {llmQuestion && (
            <Typography
              variant="subtitle1"
              style={{ fontStyle: "italic", marginBottom: "1rem" }}
            >
              AI question: {llmQuestion}
            </Typography>
          )}

          <Typography
            sx={{
              whiteSpace: "pre-line",
              fontWeight: "500",
              fontSize: "16px",
              lineHeight: "30px",
            }}
          >
            <HighlightNumbersInBrackets
              text={answer || ""}
              references={references}
            />
          </Typography>
          {Array.isArray(references) && references.length > 0 && (
            <Box
              sx={{
                marginTop: "1rem",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Button
                variant="text"
                onClick={() => setShowReferences((prevState) => !prevState)}
                startIcon={
                  showReferences ? (
                    <MdExpandLess color="#5F6368" />
                  ) : (
                    <MdExpandMore color="#5F6368" />
                  )
                }
              >
                <Typography
                  sx={{
                    fontWeight: "500",
                    fontSize: "16px",
                    lineHeight: "26px",
                    color: "#5F6368",
                  }}
                >
                  References
                </Typography>
              </Button>
              <Stack direction="row" gap="4px">
                <Tooltip title={isCopied ? "Copied!" : "Copy"}>
                  <IconButton
                    size="small"
                    onClick={() => {
                      if (isCopied) return;
                      copy(answer);
                    }}
                  >
                    {isCopied ? <IoCheckmarkDoneOutline /> : <LuCopy />}
                  </IconButton>
                </Tooltip>
                {messageId && <TalkFeedback messageId={messageId} />}
              </Stack>
            </Box>
          )}
        </Box>
      )}
    </>
  );
};
